export default [
	//注册批次管理
	{
	    path: "reg/year-batch-list",
	    name: "YearBatchList",
	    component: () => import('./YearBatchList.vue')
	},
	//招生点
	{
	    path: "reg/zsd-list",
	    name: "ZsdList",
	    component: () => import('./ZsdList.vue')
	 },
	 // 注册点列表
	 {
	    path: "info/zcd-list",
	    name: "ZcdList",
	    component: () => import('./ZcdList.vue')
	 },
	  //注册管理
	 {
	      path: "zcgl/bao-ming-list",
	      name: "BaoMingList",
	      component: () =>  import('./BaoMingList.vue')
	 },
	 {
		 path:'zcgl/apply-regInfo-edit-check-list',
		 name: "ApplyRegInfoEditCheckList",
		 component: () =>  import('./ApplyRegInfoEditCheckList.vue')
	 },
	 {
		 path:'zcgl/my-baoming-list',
		 name:'MyBaoMingList',
		 component: () =>  import('./MyBaoMingList.vue')
	 }
];






